import React from 'react';

import cx from 'classnames';
import { useCompleteModal } from 'modal.react.js';

import { AModal } from 'components/shared/AModal';
import Button from 'components/shared/Button';
import Text from 'components/shared/Typography/Text';

import { FeaturesCarousel } from './FeaturesCarousel';
import s from './MagicImportStatusModal.module.css';

type Props = {
  onClose?: () => void;
  onModalReady?: (closeModal: () => void) => void;
};

export const MagicImportProcessingModal = (props: Props) => {
  const modalControl = useCompleteModal();

  const handleClose = () => {
    props.onClose?.();
    modalControl.success(null);
  };

  React.useEffect(() => {
    if (props.onModalReady) {
      props.onModalReady(() => modalControl.success(null));
    }
  }, [props.onModalReady, modalControl]);

  return (
    <AModal
      header="PDF is being analyzed..."
      isOpen={true}
      footer={<MagicImportProcessingModalFooter submitForm={handleClose} />}
      size="lg"
      onClose={handleClose}
      isCloseOnEsc={false}
      contentClassName={s.modalContent}
    >
      <div className={cx(s.content, s.processingContent)}>
        <Text type="brandon" className={s.title}>
          In the meantime, did you know you can do all this in Safari Portal?
        </Text>
        <div className={s.sliderWrapper}>
          <FeaturesCarousel />
        </div>
      </div>
    </AModal>
  );
};

const MagicImportProcessingModalFooter = (props: { submitForm: () => void }) => {
  return (
    <div className={s.footer}>
      <Button onClick={props.submitForm} type="default" size="medium" htmlType="button">
        <div className={s.submitButton}>
          <Text type="brandon">Close</Text>
        </div>
      </Button>
    </div>
  );
};
